/* eslint-disable */
import { produce } from "immer";
import {
  RETIREMENT_QR_FAILURE,
  RETIREMENT_QR_SUCCESS,
  RETIREMENT_QR_START,
} from "../actions/types";

const retirementQr = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case RETIREMENT_QR_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case RETIREMENT_QR_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case RETIREMENT_QR_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default retirementQr;
